module.exports = __webpack_public_path__ + "media/images/notification-toggle-down-37e007cdb2deea04925dd6942b6b82e6.svg";